<template>
  <v-container fluid>
    <v-container class="px-0 px-sm-3">
      <v-row>
        <v-col offset-sm="1" cols="12" sm="10" class="pa-0">
          <section class="px-3 pl-3" v-html="page.tekst_2"/>
          <dynamic-form :id="1"/>
        </v-col>
      </v-row>
    </v-container>
  </v-container>
</template>

<script>
import page from '~/plugins/mixins/page';
import DynamicForm from '~/components/form/DynamicForm';

export default {
  components: {
    DynamicForm,
  },
  mixins: [page],
};
</script>
